// Intercepts global errors and pops up a modal.

import React from 'react';
import { connect } from 'react-redux';

import ErrorActions from 'app/error/ErrorActions';
import ErrorModal from 'app/common/components/ErrorModal';

const withGlobalErrorModal = Component => {
  const ComponentWithErrorModal = ({ errors, onClearErrors, ...props }) => (
    <div>
      <Component {...props} />
      {errors && errors.length > 0 ? (
        <ErrorModal errors={errors} onClose={onClearErrors} />
      ) : null}
    </div>
  );

  return connect(
    state => ({
      errors: state.errors,
    }),
    dispatch => ({
      onClearErrors: () => dispatch(ErrorActions.clearErrors()),
    })
  )(ComponentWithErrorModal);
};

export default withGlobalErrorModal;
